/**
 * Created by jv on 07/04/2017.
 */
const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/languagemanager");

module.exports = class RenewSubscriptionModalTemplate
{
  constructor(options)
  {
    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.dialogId = utils.isNotNull(options.dialogId) ? options.dialogId : utils.generateUIDShort();
    this.backdropIdSuffix = "-modal-backdrop";
    this.title = options.title;
    this.text = options.text;
    this.disposable = options.disposable;

    this.purchaseOrderRequired = utils.isBoolean(options.purchaseOrderRequired) ? options.purchaseOrderRequired : false;
    this.placeholder = options.placeholder;

    this.submitText = options.submitText;
    this.submitWidth = options.submitWidth;
    this.cancelText = options.cancelText;
    this.cancelPosition = options.cancelPosition;

    this.onSubmit = options.onSubmit;
    this.onCancel = options.onCancel;

    this.dialogEl = null;
    this.purchaseOrderInputEl = null;

    this.create();
  }

  get backdropId()
  {
    return this.dialogId + this.backdropIdSuffix;
  }

  get backdropExists()
  {
    return $("#" + this.backdropId).length;
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.rerender();

      this.backdrop = "<div id='" + this.backdropId + "' class='modal-backdrop fade in'></div>";

      this.dialogEl.appendTo("body");

      this.addDisposeListener();

      this._initialized = true;
    }
  }

  destroy()
  {
    var that = this;

    this.close(function()
    {
      if(utils.isNotNull(that.dialogEl) && that.dialogEl.length)
      {
        that.dialogEl.remove();
      }

      that._initialized = false;
    });
  }

  show()
  {
    this.open();
  }

  open()
  {
    var $body = $("body");
    if(!$body.hasClass("modal-open"))
    {
      $body.addClass("modal-open");
    }

    if(!this.backdropExists)
    {
      $body.append(this.backdrop);
    }

    this.dialogEl.show();
    // Reading a css property forces layout to be computed
    this.dialogEl.css("width");
    this.dialogEl.addClass("in");
  }

  hide()
  {
    this.close();
  }

  close(callback)
  {
    var $body = $("body");
    if($body.hasClass("modal-open"))
    {
      $body.removeClass("modal-open");
    }

    $("#" + this.backdropId).remove();

    this.dialogEl.removeClass("in");

    var that = this;
    setTimeout(function()
    {
      that.dialogEl.hide();

      if(utils.isFunction(callback))
      {
        callback();
      }
    }, 150);
  }

  cancel()
  {
    this.close();

    if(utils.isFunction(this.onCancel))
    {
      this.onCancel();
    }
  }

  rerender()
  {
    this.renderDialog();
    this.renderTitle();
    this.renderBody();
    this.renderButtons();
  }

  renderDialog()
  {
    this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade' style='display: block;'>" +
                        "<div class='modal-dialog'>" +
                          "<div class='modal-content clearfix'>" +
                          "</div>" +
                        "</div>" +
                      "</div>");
  }

  renderTitle()
  {
    this.dialogEl.find(".modal-content").append("<h3 class='dialog-title'>" + this.title + "</h3>");
  }

  renderBody()
  {
    var modalBodyEl = $("<div class='modal-body'></div>");

    modalBodyEl.append("<p>" + this.text + "</p>");

    if(this.purchaseOrderRequired)
    {
      var that = this;
      this.purchaseOrderInputEl = $("<input class='form-control' type='text'>").on("input", function(e)
      {
        var $this = $(this);
        if(utils.isNullOrEmpty($this.val()))
        {
          that.purchaseOrderInputEl.addClass("input-error");
        }
        else
        {
          that.purchaseOrderInputEl.removeClass("input-error");
        }
      });

      if(utils.isNotNull(this.placeholder))
      {
        this.purchaseOrderInputEl.prop("placeholder", this.placeholder);
      }

      $("<div class='form-group'></div>").append(this.purchaseOrderInputEl).appendTo(modalBodyEl);
    }

    this.dialogEl.find(".modal-content").append(modalBodyEl);
  }

  renderButtons()
  {
    var that = this;
    var buttonWrapper = $("<div class='button-wrapper clearfix'></div>");

    if(utils.isNotNull(that.cancelText) || that.cancelPosition === "top-right")
    {
      var cancelBtn;

      if(that.cancelPosition === "top-right")
      {
        cancelBtn = $("<button class='btn btn-icon frameless cross-circle dark-grey pull-right' type='button'></button>");
        that.dialogEl.find(".modal-content").prepend(cancelBtn);
      }
      else
      {
        cancelBtn = $("<button class='btn btn-main no-icon pull-right' type='button'>" + that.cancelText + "</button>");
        buttonWrapper.append(cancelBtn);
      }

      cancelBtn.on("click", function()
      {
        that.cancel();
      });
    }

    var submitBtn = $("<button class='btn btn-main no-icon pull-right' type='button'>" + that.submitText + "</button>");

    if(utils.isNotNull(that.submitWidth))
    {
      submitBtn.css("width", that.submitWidth);
    }

    submitBtn.on("click", function()
    {
      if(that.purchaseOrderRequired && utils.isNullOrEmpty(that.purchaseOrderNumber))
      {
        that.purchaseOrderInputEl.addClass("input-error");
        return;
      }

      if(utils.isFunction(that.onSubmit))
      {
        that.onSubmit(that.purchaseOrderNumber);
      }
    });

    buttonWrapper.append(submitBtn);
    this.dialogEl.find(".modal-content").append(buttonWrapper);
  }

  get purchaseOrderNumber()
  {
    var purchaseOrderNumber = null;

    if(this.purchaseOrderRequired && utils.isNotNull(this.purchaseOrderInputEl) && this.purchaseOrderInputEl.length)
    {
      purchaseOrderNumber = this.purchaseOrderInputEl.val();
    }

    return purchaseOrderNumber;
  }

  addDisposeListener()
  {
    var that = this;

    that.dialogEl.off().on("click", function(e)
    {
      if(e.target.className === "modal-content" || $(e.target).closest(".modal-content").length)
      {
        e.stopPropagation();
        return;
      }

      that.cancel();
    });
  }
};



// WEBPACK FOOTER //
// ./app/js/templates/renew-subscription-dialog.template.js